import * as React from 'react';
import type { Accessors } from '#types/accessor.ts';
import { Circle, CircleProps } from './circle';

export type CirclesProps<Datum, XResult, YResult> = Omit<
  CircleProps<Datum, XResult, YResult>,
  'datum'
> & {
  data: Datum[];
  accessors: Accessors<Datum, XResult, YResult>;
  ariaDatumLabel: (datum: Datum) => string;
};

export function Circles<Datum, XResult, YResult>({
  accessors,
  data,
  ariaDatumLabel,
}: CirclesProps<Datum, XResult, YResult>) {
  return (
    <>
      {data
        // Only render circles with values.
        .filter((datum) => accessors.yAccessor(datum) != null)
        .map((datum) => (
          <Circle
            key={`circle-${accessors.xAccessor(datum)}:${accessors.yAccessor(
              datum,
            )}`}
            datum={datum}
            accessors={accessors}
            aria-label={ariaDatumLabel(datum)}
          />
        ))}
    </>
  );
}
